import React, { useEffect, useState, useCallback } from "react";
import { supabase } from "../../supabaseClient"; // Provjeri je li putanja do tvog klijenta točna
import { motion } from "framer-motion";

const HomeSponsors = ({ turnirId }) => {
  const [sponsors, setSponsors] = useState([]);

  const fetchHomeSponsors = useCallback(async () => {
    if (!turnirId) return;

    try {
      // Dohvaćamo samo vidljive sponzore za ovaj specifični turnir iz nove tablice admin_sponzori
      const { data, error } = await supabase
        .from("admin_sponzori")
        .select("*")
        .eq("turnir_id", turnirId)
        .eq("is_visible", true)
        .order("position", { ascending: true });

      if (error) throw error;
      setSponsors(data || []);
    } catch (error) {
      console.error(
        "Greška pri dohvaćanju sponzora na početnoj:",
        error.message,
      );
    }
  }, [turnirId]);

  useEffect(() => {
    fetchHomeSponsors();
  }, [fetchHomeSponsors]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  // Ako nema turnira ili nema sponzora, ne prikazujemo sekciju
  if (!turnirId || sponsors.length === 0) return null;

  return (
    <section className="home-sponsors">
      <div className="section-header">
        <span className="line"></span>
        <h3>Sponzori turnira</h3>
        <span className="line"></span>
      </div>

      <motion.div
        className="sponsors-grid"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
      >
        {sponsors.map((sponsor) => (
          <motion.a
            href={sponsor.web_url || "#"}
            key={sponsor.id}
            className="sponsor-card"
            target={sponsor.web_url ? "_blank" : "_self"}
            rel="noopener noreferrer"
            title={sponsor.name}
            style={{ "--brand-color": sponsor.bg_color || "#FFFFFF" }}
            variants={itemVariants}
          >
            <div className="logo-wrapper">
              <img src={sponsor.logo_url} alt={sponsor.name} />
            </div>
          </motion.a>
        ))}
      </motion.div>
    </section>
  );
};

export default HomeSponsors;
